export default "__VITE_ASSET__D3hq9N1V__"